import React from "react";
import { Grid } from "@material-ui/core";
import {
  InputHLPure,
  ArrowBtnHLPure,
  ButtonHLPure,
  SubtitlePageHLPure,
  DialogSystemGLPure,
} from "../../../pures";
import "./user-administration-datails.view.css";
import { profileIconDefault } from "../../../../assets/logos/icons";

const UserAdministrationDetailsView = ({
  selectedUser,
  hideShowDetails,
  setNameComponentUser,
  setHeaderTitleinDetail,
  setShowComponentDetail,
  showDetailComponent,
  setShowDetails,
  imgProfileSubtitle,
  showLoadingRequesting,
  showCompletedRequesting,
  showErrorRequesting,
  toggleCompletedRequesting,
  toggleLoadingRequesting,
  toggleErrorRequesting,
  message,
  t
}) => {
  const redirectToComponets = (e) => {
    setNameComponentUser(e.currentTarget.dataset.id);
    setHeaderTitleinDetail({ clicked: true, name: e.currentTarget.dataset.id });
    setShowComponentDetail(true);
  };

  return (
    <>
      <Grid
        item
        lg={12}
        md={12}
        xs={12}
        sm={12}
        className="userAdministrationDetailsView-header"
      >
        <SubtitlePageHLPure
          subtitle={t("userAdministrationDetailsView.title")}
          imgProfile={profileIconDefault}
          profileImg={imgProfileSubtitle}
          tooltipShow
          informationIcon={false}
          justShowImg
          openTooltipDescription={false}
        />
      </Grid>

      <Grid
        item
        className="userAdministrationDetailsView-body"
        xs={12}
        lg={12}
        md={12}
        sm={12}
        es={12}
      >
        {/*Container primera seccion de items, fila*/}
        <Grid
          item
          lg={12}
          md={12}
          sm={12}
          xs={12}
          className="userAdministrationDetailsView-form"
        >
          {/*Container first second items, col 1*/}

          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            className="userAdministrationDetailsView-inputs"
          >
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              es={3}
              className="userAdministrationDetailsView-col1"
            >
              <Grid item className="userAdministrationDetailsView-inputHLPure">
                <InputHLPure
                  labelInput={t("userAdministrationDetailsView.user.name")}
                  valueInput={selectedUser.firstName}
                  typeInput={"text"}
                  inputActive
                  tooltipShow={false}
                />
              </Grid>
              <Grid item className="userAdministrationDetailsView-inputHLPure">
                <InputHLPure
                  labelInput={t("userAdministrationDetailsView.lastname")}
                  valueInput={selectedUser.firstLastName}
                  inputActive
                  tooltipShow={false}
                />
              </Grid>
              <Grid item className="userAdministrationDetailsView-inputHLPure">
                <InputHLPure
                  labelInput={t("userAdministrationDetailsView.second.lastname")}
                  valueInput={selectedUser.secondLastName}
                  inputActive
                  tooltipShow={false}
                />
              </Grid>
            </Grid>
            {/*Container second section items, col 2*/}
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              className="userAdministrationDetailsView-col2"
            >
              <Grid item className="userAdministrationDetailsView-inputHLPure">
                <InputHLPure
                  labelInput={t("userAdministrationDetailsView.cellphone.number")}
                  valueInput={selectedUser.cellphoneNumber}
                  inputActive
                  tooltipShow={false}
                />
              </Grid>
              <Grid item className="userAdministrationDetailsView-inputHLPure">
                <InputHLPure
                  labelInput={t("userAdministrationDetailsView.curp")}
                  valueInput={selectedUser.curp}
                  inputActive
                  tooltipShow={false}
                />
              </Grid>
              <Grid item className="userAdministrationDetailsView-inputHLPure">
                <InputHLPure
                  labelInput={t("userAdministrationDetailsView.rfc")}
                  valueInput={selectedUser.rfc}
                  inputActive
                  tooltipShow={false}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          lg={12}
          md={12}
          sm={12}
          xs={12}
          className="userAdministrationDetailsView-btnGroup"
        >
          <div className="userAdministrationDetailsView-spaceBtns">
            <ArrowBtnHLPure
              primary={false}
              textArrowBtn={t("userAdministrationView.grid.actions.assign.roles")}
              onClickArrowBtn={() => {
                setNameComponentUser(t("userAdministrationView.grid.actions.assign.roles"));
                setShowDetails(true);
              }}
              dataSetProp={t("userAdministrationView.grid.actions.assign.roles")}
            />
          </div>
          <div className="userAdministrationDetailsView-spaceBtns">
            <ArrowBtnHLPure
              primary={false}
              textArrowBtn={t("userAdministrationView.grid.actions.assign.companies")}
              onClickArrowBtn={() => {
                setNameComponentUser(t("userAdministrationView.grid.actions.assign.companies"));
                setShowDetails(true);
              }}
              dataSetProp={t("userAdministrationView.grid.actions.assign.companies")}
            />
          </div>
          <div className="userAdministrationDetailsView-spaceBtns">
            <ArrowBtnHLPure
              primary={false}
              textArrowBtn={t("userAdministrationView.grid.actions.disable")}
              onClickArrowBtn={() => {
                setNameComponentUser(t("userAdministrationView.grid.actions.disable"));
                setShowDetails(true);
              }}
              dataSetProp={t("userAdministrationView.grid.actions.disable")}
            />
          </div>
          <ButtonHLPure
            primary
            nameBtn={t("button.return")}
            onClickBtn={hideShowDetails}
          />
          <DialogSystemGLPure
            showLoadingRequesting={showLoadingRequesting}
            showCompletedRequesting={showCompletedRequesting}
            showErrorRequesting={showErrorRequesting}
            toggleLoadingRequesting={toggleLoadingRequesting}
            toggleCompletedRequesting={toggleCompletedRequesting}
            toggleErrorRequesting={toggleErrorRequesting}
            message={message}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default UserAdministrationDetailsView;
